import katex from "katex";

// 将deltaToHtml转换的字符串转为html内容
export function getHtmlString(quillToHtml){
  quillToHtml.renderCustomWith(function (customOp, contextOp) {
    if (customOp.insert.type === "audio") {
      return `<span class="ql-audio"><audio controls="controls" preload="auto" controlsList="nodownload" src="${customOp.insert.value}" resourceinfo='${customOp.attributes.resourceInfo}'><source src="${customOp.insert.value}"></audio><span>`;
    } else if (customOp.insert && customOp.insert.type === "customVideo") {
      if (customOp.insert.value.startsWith("https://vod.keymemox.com")) {
        return `<video class="ql-video" src="${customOp.insert.value}" controls><source src="${customOp.insert.value}" type="video/mp4">您的浏览器不支持 Video 标签。</video>`; // 返回自定义的HTML字符串
      } else {
        return `<iframe class="ql-video" controls preload="auto" controlsList="nodownload nofullscreen noplaybackrate" src="${customOp.insert.value}"> <source src="${customOp.insert.value}" type="video/mp4">Your browser does not support the video tag.</iframe>`; // 返回自定义的HTML字符串
      }
    } else if (customOp.insert && customOp.insert.type === "table") {
      return renderTableHtml(customOp.insert.value); // 返回自定义的HTML字符串
    }
  });
  quillToHtml.afterRender((groupType, htmlString) => {
    // 创建DOM解析器
    const parser = new DOMParser();
    // 解析HTML字符串
    const doc = parser.parseFromString(htmlString, "text/html");
    const spans = doc.querySelectorAll("span.ql-formula");

    // 遍历所有span标签并替换内容
    spans.forEach((span) => {
      let katexHtml = katex.renderToString(span.innerText, {
        throwOnError: false,
      });
      const regex = /<span class="katex-mathml">([\s\S]*?)<\/span>/;
      const match = regex.exec(katexHtml);
      let targetHtmlString = match ? match[0] : span.innerText;
      span.classList.add("ql-formula-katex");
      span.innerHTML = targetHtmlString;
    });
    return doc.body.innerHTML;
  });
  let htmlString = quillToHtml.convert();
  return htmlString;
}